export default "__VITE_ASSET__D3F0Ng9i__"